import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartType } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { ToastrService } from 'ngx-toastr';
import { ViewSkillComponent } from 'src/app/course-management/skill/view-skill/view-skill.component';
import { SwitchDashboardComponent } from 'src/app/course-management/switch-dashboard/switch-dashboard.component';
import { GlobalClass } from 'src/app/global/global-class';
import { LogoutWarningModalComponent } from 'src/app/logout/logout-warning-modal/logout-warning-modal.component';
import { FileServiceService } from 'src/app/service/file-service.service';
import { SkillServiceService } from 'src/app/service/skill-service.service';
import { StudentService } from 'src/app/service/student.service';
import { SharedDataService } from 'src/app/services/sharedData.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-class-skill-reports',
  templateUrl: './class-skill-reports.component.html',
  styleUrls: ['./class-skill-reports.component.scss']
})
export class ClassSkillReportsComponent implements OnInit {

  showDropDown = true;
  results = false;
  mainSKillSelected = false;
  mainSkills = false;
  showSpinner = true;
  currentRole="TEACHER";
  index : number = 0;
  userId!: string;
  resultsExist = false;
  userName : any;
  loggedUser : any;
  loggedInUser : any;
  theme: string = '';
  public screenWidth: any;
  public screenHeight: any;
  classId!: string;
  selectedSkillNames: string[] = [];  
  unsafeImageUrl : any;
  safeImageUrl : any;
  safeStudentUrl : any;
  unsafeStudentUrl : any;

  safeUrl : any;
  unsafeUrl : any;

  datae: any[] = [];  

  config = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    class: 'modal-md'
  };

  skillResults : any[] =[{

                              parentSkillId : '',
                              skillDescription: '',
                              skillId: '',
                              skillName:'',
                              skillStatus: '',
                              collapsedState: '',
                              safeUrl : '',
                              skillImage : '',

                              resultlist: [{
                                            fkSkillId: '',
                                            fkStudentId:'',
                                            fkSubjectId: '',
                                            parentSkillName: '',
                                            resultHistory: '',
                                            resultId: '',
                                            resultStatus: '',
                                            resultSuggestion: '',
                                            skillDescription: '',
                                            skillName: '',
                                            skillScore:'',
                                            safeUrl : '',
                                            skillImage : '',
                                            lastScore : ''
                                            }]
                                }];

                                actualResultlist:any[] = [{
                                  fkSkillId: '',
                                  fkStudentId:'',
                                  fkSubjectId: '',
                                  parentSkillName: '',
                                  resultHistory: '',
                                  resultId: '',
                                  resultStatus: '',
                                  resultSuggestion: '',
                                  skillDescription: '',
                                  skillName: '',
                                  skillScore:'',
                                  safeUrl : '',
                                  skillImage : '',
                                  lastScore : ''
                                  }]

  selectedMainSkill : any ={
                                parentSkillId : '',
                                skillDescription: '',
                                skillId: '',
                                skillName:'',
                                skillStatus: '',
                                collapsedState: '',

                                resultlist: [{
                                              fkSkillId: '',
                                              fkStudentId:'',
                                              fkSubjectId: '',
                                              parentSkillName: '',
                                              resultHistory: '',
                                              resultId: '',
                                              resultStatus: '',
                                              resultSuggestion: '',
                                              skillDescription: '',
                                              skillName: '',
                                              skillScore:'',
                                              lineChartData :[{ 
                                                data: [1,2,2,1,2,2,1], 
                                                label : 'progress'
                                              }]
                                              }]
  }

  lineChartData: any[] = [
    { data: [8, 7, 9, 8, 7, 8], label : 'progress'},
  ];
  

  lineChartLabels: Label[] = ['', '', '', '', '', ''];

  lineChartColors: Color[] = [
    {
      borderColor: 'black',
      backgroundColor: '#b9d8f3',
    },
  ];

  lineChartLegend = true;
  lineChartPlugins = [];
  lineChartType : ChartType = 'line';

  lineChartOptions = {
    
    legend: {
      onClick: (e: { stopPropagation: () => any; }) => e.stopPropagation()
  },
 
    elements: {
      line: {
          tension: 0
      }
  },
    responsive: true,
    scales: {
        xAxes: [{
            gridLines: {
                color: "rgba(0, 0, 0, 0)",
               display: false
            }
        }],
        yAxes: [{
          
            display: false
       ,
            gridLines: {
              drawBorder: false,
              display: false,
                color: "rgba(0, 0, 0, 0)",
                
            }   
        }]
    }
}
  showMainPanel = false;

  navbarTitle : any

  selectedStudentId : any;
  students : any[] = [{
    studentId: '',
    fkClass: '',
    fkUserRoleOffice: '',
    studentStatus: '',
    studentName: '',
    studentImage : '',
    dob : '',
    email : '',
    phone : '',
    safeStudentUrl : ''
}]

selectedStudent : any = {
  studentId: '',
  fkClass: '',
  fkUserRoleOffice: '',
  studentStatus: '',
  studentName: '',
  studentImage : '',
  dob : '',
  email : '',
  phone : '',
  safeStudentUrl : ''
}

  subjectId: any;

  constructor(private sharedDataService: SharedDataService, 
              private imageService : FileServiceService,
              private sanitizer : DomSanitizer,
              private ngbModalService: NgbModal,
              public router: Router,
              private skillService : SkillServiceService,
              public route : ActivatedRoute,
              private toastr : ToastrService,
              private studentService : StudentService ) { }

              groupedView = false;

  ngOnInit(): void {

this.selectedStudentId = "";

this.navbarTitle = GlobalClass.navbarTitle;

this.screenWidth = window.innerWidth;
this.screenHeight = window.innerHeight;

this.subjectId = this.route.snapshot.params['subjectId'];
this.classId = this.route.snapshot.params['classId'];

this.loggedUser = localStorage.getItem('loggedUser');
this.loggedInUser = JSON.parse(this.loggedUser);
this.userName = this.loggedInUser?.firstName + ' ' + this.loggedInUser?.lastName;
this.theme = this.sharedDataService.getCardOfficeTheme();
this.userId = this.loggedInUser.userId;

this.getStudents();

}

openSubSkillDetailsModal(skillResult : any){
  this.config.class = 'modal-md';
  const modalRef = this.ngbModalService.open( ViewSkillComponent,
    {
      size : 'md',
      scrollable: true,
      windowClass: 'app-modal-window',
      keyboard: false
    });
  let data = {
    skillResult : skillResult
  }

  modalRef.componentInstance.fromParent = data;
    modalRef.result.then((result) => {
    }, (reason) => {
    });

  modalRef.componentInstance.passEntry.subscribe((receivedEntry : string) => {
  });    
}

showMainSkillResult(){

  this.results = false;
  this.mainSKillSelected = false;
  this.mainSkills = true;

}

get backgroundStyle(){
  let globalClass : GlobalClass = new GlobalClass() ;
  return globalClass.backgroundStyle(this.loggedInUser.offices[0].theme);
}

exploreMainSkillResult(skillId : any){

  this.skillResults.forEach((val)=>{
    if(val.skillId === skillId){
      this.selectedMainSkill = val;
      this.mainSKillSelected = true;
      this.mainSkills = false;
      this.results = true;
    }
  });
}

showDropDownToChoose(){
  this.showMainPanel=false
  this.showDropDown = true;
}

// authorized
getStudents(){
  this.students = [];
  this.studentService.getStudentsInaClassForTeacher(environment.apiUrl +  "student/getStudentsInClassForTeacher/" + this.classId).then(
    data=>{
      this.students.pop();

      for(var index in data){
        this.students.push( { 'studentId' : data[index].studentId, 
                              'fkClass' : data[index].fkClass,
                              'fkUserRoleOffice' : data[index].fkUserRoleOffice,
                              'studentStatus' : data[index].studentStatus,
                              'studentName' : data[index].studentName,
                              'studentImage' : data[index].studentImage,
                              'dob' : data[index].dob,
                              'email' : data[index].email,
                              'phone' : data[index].phone,
                              'safeStudentUrl' : this.safeStudentUrl                                
                                    });
}

if(this.students===undefined || this.students.length===0){
this.showSpinner=false;
this.toastr.show('No Students to display !');
}

let count : number = 0;
this.students.forEach( (value) => {
        count++;
this.imageService.getUserImage(value.studentImage).subscribe(
  data=>{
    this.unsafeStudentUrl = URL.createObjectURL(data);
    this.safeStudentUrl = this.sanitizer.bypassSecurityTrustUrl( this.unsafeStudentUrl);

    value.safeStudentUrl = this.safeStudentUrl;

    if(count===this.students.length){        
      setTimeout(()=>{                           //timer
        this.showSpinner = false;
   }, 2500);
    }
   });
 }); 
});
}

collapseActivityCardContent2(id : string){
      
  this.skillResults.forEach((value)=>{

    if(value.skillId === id){

      if(value.collapsedState === true){
        value.collapsedState = false
      } else if(value.collapsedState === false){
        value.collapsedState = true
      }

    }
  });
}

// authorized
getSkillResults(){
this.showSpinner = true;
this.showDropDown = false;
this.showMainPanel = false;
this.mainSKillSelected = false;
this.results = false;
  this.students.forEach((value)=>{
    if(value.studentId === this.selectedStudentId){
      this.selectedStudent = value;
      this.showMainPanel = true;
      this.showSpinner = false;
    }
  });

  this.skillService.getStudentSkillResultForReport(environment.apiUrl + "result/getStudentSkillResultForReport/" + this.selectedStudentId).then(
    res=>{
      this.actualResultlist = [];
      this.skillResults = res;
      this.mainSkills = true;

      this.skillResults.forEach((val)=>{

        val.collapsedState = false;

        this.imageService.getSkillImage( val.skillImage ).subscribe(
          data=>{
            this.unsafeUrl = URL.createObjectURL(data);
            val.safeUrl = this.sanitizer.bypassSecurityTrustUrl(this.unsafeUrl);
          });

        val.resultlist.forEach((value : any)=>{

          this.imageService.getSkillImage( value.skillImage ).subscribe(
            data=>{
              this.unsafeUrl = URL.createObjectURL(data);
              value.safeUrl = this.sanitizer.bypassSecurityTrustUrl(this.unsafeUrl);
              });

            if(value.resultHistory !== undefined && value.resultHistory !== null){

          var myArray = value.resultHistory.split(",");
  for(var i=0; i<myArray.length; i++) { 
    this.datae[i] = +myArray[i]; 
  }

  value.lastScore = this.datae[this.datae.length - 1] 
    
          value.lineChartData = [
            { data: this.datae,
               label : 'progress'},
          ];
          this.datae = [];
        }

        value.parentSkillName = val.skillName;
        value.skillScore = Math.round(value.skillScore * 10) / 10;
        this.actualResultlist.push(value);
        });
      })
      
    });
}

goToAccountPage(){
  this.router.navigate(['user-account', this.userId]);
}

goToHomePage(){
  this.router.navigate(['/dashboard/teacher']);
}

getColor(){
  this.sharedDataService.setfooterColor(this.loggedInUser.offices[0].theme);
  return this.loggedInUser.offices[0].theme + '!important';
}

logOut(): void {
  this.config.class = 'modal-md';
  const modalRef = this.ngbModalService.open( LogoutWarningModalComponent,
    {
      size : 'md',
      scrollable: true,
      windowClass: 'app-modal-window',
      keyboard: false
    });
  let data = {
   email : this.loggedInUser.email 
  }

  modalRef.componentInstance.fromParent = data;
    modalRef.result.then((result) => {
    }, (reason) => {
    });

  modalRef.componentInstance.passEntry.subscribe((receivedEntry : string) => {
  });  
}

goBack() {
  this.router.navigate(['/dashboard/user']).then();
}

switchDashboard(){
  this.config.class = 'modal-md';
  const modalRef = this.ngbModalService.open( SwitchDashboardComponent,
    {
      size : 'sm',
      scrollable: true,
      windowClass: 'app-modal-window',
      keyboard: false
    });
  let data = {
    userId : this.userId,
    currentRole : this.currentRole
  }

  modalRef.componentInstance.fromParent = data;
    modalRef.result.then((result) => {
    }, (reason) => {
    });

  modalRef.componentInstance.passEntry.subscribe((receivedEntry : string) => {
  });    
}

computeSkillReport(){

  this.studentService.generateOfficeStudentsSkillReport(environment.apiUrl + "student/generateClassStudentsSkillReport/" + this.classId).then(
    res=>{
      this.toastr.success("Skill report generated");
    });

}

reloadPage() {
  window.location.reload();
}
}
